export interface IPresentationFolder {
    _id: string;
    name: string;
    created: string;
    lastModified: string;
    presentationCount: number;
}

export const FOLDER_FILTER_ALL = 'all';
export const FOLDER_FILTER_UNFILED = 'unfiled';
